// Какие строки объяснения показывать под выбранным навыком.
//
// Вынесено из `AimCard` и покрыто тестами не ради чистоты. Первая версия
// ветвилась выражением `own ? … : via ? … : null` и роняла ровно тот случай,
// ради которого вся строка и заводилась: ученик провалил свой зачёт (1 из 3),
// позже сдал зачёт по вершине выше, навык зачло её замыканием — и экран
// показывал «зачёт 9 сентября: 1 из 3» под надписью «уже зачтён», а причину
// прятал. Правило из двух флагов проверяется пятью строчками теста;
// тройное выражение в JSX не проверялось ничем.
import type { SkillCredit } from "../contract";

export interface CreditLines {
  /** Строка своего зачёта: «зачёт 9 сентября: 2 из 3». */
  own: boolean;
  /** Строка замыкания: «стоит под зачётом „…“». */
  via: boolean;
}

/**
 * Свой зачёт показывается всегда, когда он был, — сданный или нет: провал
 * ничего не отнимает, но объясняет, почему навык открыт.
 *
 * Замыкание — когда оно есть и своим зачётом состояние не объяснено. Сдавший
 * навык сам видит это одной строкой, и вторая ему уже ничего не сообщает; а
 * вот у провалившего замыкание — единственное объяснение «уже зачтён», и без
 * него на экране остаётся противоречие.
 */
export function creditLines(credit: SkillCredit): CreditLines {
  const ownPassed = credit.own !== null && credit.own.correct >= credit.own.total;
  return {
    own: credit.own !== null,
    via: credit.via !== null && !ownPassed,
  };
}
